<template>
  <div class="box-sizing">
    <div :class="width == 'widthone' ? 'tab_lefttwo' : 'tab_left'">
      <!-- <logo :collapse="isCollapse" /> -->
      <el-scrollbar wrap-class="scrollbar-wrapper">
        <div class="logobox">
          <img src="../../assets/logohome.png" alt="" />
          <!-- <img
            class="lastImg"
            v-if="isCollapse != true"
            src="../../assets/logotext.png"
            alt=""
          /> -->
          <p class="logotitile" v-if="isCollapse != true">仰和影像云</p>
        </div>
        <el-menu
          router
          :collapse="isCollapse"
          background-color="#F2F6F4"
          text-color="#7E7E7E"
          default-active="2"
          :unique-opened="false"
          active-background-color="#F9F9F9"
          active-text-color="#7E7E7E"
          :collapse-transition="true"
        >
          <template v-for="item in silderBarArray">
            <el-submenu
              v-if="item.children != '' && item.children[0].model != 3"
              :index="item.id + ''"
              :key="item.id + ''"
            >
              <template slot="title">
                <!-- <i :class="item.icon" /> -->
                <img v-if="item.name == '系统管理'" class="listicon" src="../../assets/系统管理@2x.png" alt="">
                <img v-if="item.name == '统计分析'" class="listicon" src="../../assets/统计分析@2x.png" alt="">
                <img v-if="item.name == '配置管理'" class="listicon" src="../../assets/配置管理@2x.png" alt="">
                <img v-if="item.name == '质控管理'" class="listicon" src="../../assets/质控管理@2x.png" alt="">
                <span v-if="item.visible != false">{{ item.name }}</span>
              </template>
              <el-menu-item
                v-for="items in item.children"
                :key="items.id"
                :index="items.url"
                v-if="items.model!=3"
              >
                <img v-if="items.name == '用户列表'" class="listicon" src="../../assets/用户列表@2x.png" alt="">
                <img v-if="items.name == '菜单列表'" class="listicon" src="../../assets/菜单列表@2x.png" alt="">
                <img v-if="items.name == '角色列表'" class="listicon" src="../../assets/角色列表@2x.png" alt="">
                <img v-if="items.name == '医疗机构统计'" class="listicon" src="../../assets/医疗机构统计@2x.png" alt="">
                <img v-if="items.name == '工作量统计'" class="listicon" src="../../assets/工作量统计@2x.png" alt="">
                <img v-if="items.name == '设备管理'" class="listicon" src="../../assets/设备管理@2x.png" alt="">
                <img v-if="items.name == '医院管理'" class="listicon" src="../../assets/医院管理@2x.png" alt="">
                <span >{{ items.name }}</span>
              </el-menu-item>
            </el-submenu>
            <template v-else>
              <el-menu-item
                v-if="item.visible != false"
                :index="item.url"
                :key="item.id"
              >
                <!-- <i :class="item.icon"></i> -->
                <img v-if="item.name == '检查登记'" class="listicon" src="../../assets/检查登记@2x.png" alt="">
                <img v-if="item.name == '模板管理'" class="listicon" src="../../assets/模板管理@2x.png" alt="">
                <img v-if="item.name == '检查记录'" class="listicon" src="../../assets/检查记录@2x.png" alt="">
                <span>{{ item.name }}</span>
              </el-menu-item>
            </template>
          </template>
        </el-menu>
      </el-scrollbar>
    </div>
    <div :class="isCollapse == false ? 'tab_right' : 'tab_rightactive'">
      <div class="header_box">
        <div @click="clickShow">
          <img class="Group" src="../../assets/Group4.png" alt="" />
        </div>
        <div class="user_box">
          <el-col :span="12">
            <el-dropdown>
              <span class="el-dropdown-link">
                <span class="headerimg">
                  <img :src="userheader || this.GLOBAL.BASE_URL + 'backend/sign/headers/1660184962612502085.jpg'" alt="" />
                </span>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item icon="el-icon-user">{{
                  username
                }}</el-dropdown-item>
                <label @click="ChangePassword">
                <el-dropdown-item icon="el-icon-edit"
                  ><span
                    >修改密码</span
                  ></el-dropdown-item
                >
                </label>
                <label @click="dialogVisible = true">
                  <el-dropdown-item icon="el-icon-bell"
                  ><span >关于</span></el-dropdown-item
                >
                </label>
                <label @click="signOut">
                <el-dropdown-item icon="el-icon-circle-close"
                  ><span >退出</span></el-dropdown-item
                >
                </label>
              </el-dropdown-menu>
            </el-dropdown>
          </el-col>
        </div>
        <el-dialog
  title="关于"
  :visible.sync="dialogVisible"
  width="100"
  :before-close="handleClose">
  <span>
    医学影像传输与处理云平台软件<br>
规格型号:youngmed-pacs<br>
发布版本:1<br>
生产日期: 2023-01-16<br>
使用期限:5 年<br>
<br>
注册人/生产企业:仰和华健数字医疗科技(上海)有限公司<br>
注册地址:中国(上海)自由贸易试验区临港新片区环湖西二路 888 号 C 楼<br>
生产地址:中国(上海)自由贸易试验区临港新片区环湖西二路 888 号 C 楼 <br>
联系电话:021-50308116<br>
电子邮件:support@youngmed.com
其他内容详见说明书
  </span>
  <span slot="footer" class="dialog-footer">
    <!-- <el-button @click="dialogVisible = false">取 消</el-button> -->
    <!-- <el-button type="primary" @click="dialogVisible = false">确 定</el-button> -->
  </span>
</el-dialog>
      </div>
      <div>
        <el-breadcrumb class="Navigation" separator="/">
          <el-breadcrumb-item class="homecolor" :to="{ path: pathUrl }"
            >首页</el-breadcrumb-item
          >
          <el-breadcrumb-item
            ><a class="Group Groupcolor">{{
              breadcrumb
            }}</a></el-breadcrumb-item
          >
        </el-breadcrumb>
      </div>
      <div class="right_content">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
// import { menuList, getAllApi } from '../../../api/syste3m'
// import { mapGetters } from 'vuex'
// import Logo from './Logo'
// import SidebarItem from './SidebarItem'
// import variables from '@/styles/variables.scss'

export default {
  //   components: { Logo },
  computed: {
    // ...mapGetters([
    //   'permission_routes',
    //   'sidebar'
    // ]),
    // activeMenu() {
    //   const route = this.$route;
    //   console.log(route);
    //   const { meta, path } = route;
    //   // if set path, the sidebar will highlight the path you set
    //   if (meta.activeMenu) {
    //     return meta.activeMenu;
    //   }
    //   return path.replace("/index", "");
    // },
    // showLogo() {
    //   return this.$store.state.settings.sidebarLogo
    // },
    // variables() {
    //   return variables
    // },
    // isCollapse() {
    //   return !this.sidebar.opened
    // }
  },
  data() {
    return {
      dialogVisible: false,
      pathUrl: "",
      breadcrumb: "",
      silderBarArray: [],
      username: "www",
      userheader: this.GLOBAL.BASE_URL + "backend/sign/headers/1660184962612502085.jpg",
      NavigateItem: [
        {
          title: "首页",
          key: "1",
          path: "",
          items: [],
        },
        {
          title: "找人才",
          key: "2",
          path: "",
          items: [
            {
              title: "选项1",
              key: "2-1",
              path: "",
            },
            {
              title: "选项2",
              key: "2-2",
              path: "",
            },
          ],
        },
        {
          title: "找资金",
          key: "3",
          path: "",
          items: [
            {
              title: "选项1",
              key: "3-1",
              path: "",
            },
            {
              title: "选项2",
              key: "3-2",
              path: "",
            },
          ],
        },
        {
          title: "提身价",
          key: "4",
          path: "",
          items: [
            {
              title: "选项1",
              key: "4-1",
              path: "",
            },
            {
              title: "选项2",
              key: "4-2",
              path: "",
            },
          ],
        },
      ],
      isCollapse: false,
      width: "",
    };
  },
  mounted() {
    console.error(this.$router.history.current.name);
    this.breadcrumb = this.$router.history.current.name;
  },
  watch: {
    $route(to, from) {
      console.error(to.name);
      this.breadcrumb = to.name;
    },
  },
  created() {
    if (sessionStorage.getItem("token")) {
      this.getMenuList();
    } else {
      //this.$router.replace("/login");
    }
  },
  methods: {
    handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      },
    ChangePassword() {
      this.$router.push({
        path: "/sys/changepassword",
      });
    },
    signOut() {
      if(sessionStorage.getItem("loadType") == '1'){
      this.$confirm("此操作将退出当前用户, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          localStorage.removeItem("token");
          this.$message({
            type: "success",
            message: "退出成功",
          });
          this.$router.push({
            path: "/login?loadType=1",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
      }else {
      this.$confirm("此操作将退出当前用户, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          localStorage.removeItem("token");
          this.$message({
            type: "success",
            message: "退出成功",
          });
          this.$router.push({
            path: "/login",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
      }

    },
    clickShow() {
      this.isCollapse = !this.isCollapse;
      console.log(this.isCollapse);
      if (this.isCollapse == true) {
        this.width = "widthone";
      } else {
        this.width = "widthtwo";
      }
    },
    getMenuList() {
      //   menuList({}).then(res => {
      //     console.log(res)
      //     this.silderBarArray = res.data
      //   }).catch(err => {
      //     console.log(err)
      //   })
      // this.token = sessionStorage.getItem('token')
      depot
        .get({
          url: "/backend/info/queryMyInfo",
          params: {
            token: sessionStorage.getItem("token"),
          },
          config: {},
        })
        .then((res) => {
          if (res.code == 500006) {
            this.$router.push({
              path: "/sys/changepassword",
            });
            return;
          }
          console.log(res);
          this.silderBarArray = res.data.backendMenus;
          this.username = res.data.userName;
          this.userheader = res.data.header;
          if (res.data.backendMenus[0].url == "") {
            this.pathUrl = res.data.backendMenus[1].url;
            console.log(this.pathUrl);
          } else {
            this.pathUrl = res.data.backendMenus[0].url;
            console.log(this.pathUrl);
          }
        });
    },
  },
  beforeRouteLeave(to,from,next){
   to.meta.keepAlive = false
   next(1)
 },
};
</script>
<style>
.Navigation {
  margin-top: 29px;
  margin-bottom: 19px;
  padding-left: 15px;
}
.tab_right {
  width: calc(100% - 185px);
  background: #f9f9f9;
}
.tab_rightactive {
  width: calc(100% - 64px);
  background: #f9f9f9;
  /* transition: all 2s ease; */
}
.el-submenu .el-menu-item {
  min-width: 100px!important;
}
.header_box {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 15px;
  box-sizing: border-box;
  background: #fff;
}
.box-sizing {
  display: flex;
}
.tab_left {
  width: 185px;
  height: 100vh;
  background: #f2f6f4;
  /* transition: all 0.3s ease; */
}
.headerimg {
  width: 45px;
  height: 45px;
  display: inline-block;
  border-radius: 50%;
  margin-left: 20px;
  object-fit: contain;
  margin-right: 20px;
}
.headerimg img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
}
.el-icon-switch-button {
  font-size: 25px;
}
.right_content {
  padding: 0px 15px;
  box-sizing: border-box;
  height: calc(100vh - 150px);
  overflow-y: scroll;
}
.logobox {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 16px;
  margin-bottom: 20px;
}
.logobox img:last-child {
  width: 146px;
  height: 36px;
  object-fit: contain;
  /* margin-left: 13px; */
}
.lastImg {
  margin-left: 13px;
}
.logobox img:first-child {
  /* margin-right: 13px; */
  width: 40px;
  height: 40px;
  object-fit: contain;
}
.user_box {
  display: flex;
  align-items: center;
}
.tab_lefttwo {
  width: 64px;
  height: 100vh;
  background: #f2f6f4;
  /* transition: all 0.1s ease; */
}
.logotitile {
  font-weight: 500;
  font-size: 20px;
  margin-left: 10px;
}
.Group {
  cursor: pointer;
}
.Navigation .Groupcolor {
  color: #999999!important;
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
}
.el-breadcrumb__inner.is-link {
  font-size: 16px!important;
  color: #333333!important;
}
.Navigation .homecolor {
  color: #aeaeae !important;
}
.el-menu-item.is-active {
  border-left: 5px solid #009b43;
  background: #f9f9f9 !important;
  color: #000 !important;
}
/* .el-menu-item {
  border-left: 5px solid red;
} */
.listicon {
  width: 14px;
  height: 14px;
  object-fit: contain;
}
</style>



// WEBPACK FOOTER //
// src/views/dashboard/index.vue